import { getCanonicalUrlForPath, getSiteOrigin, siteDefaults } from './siteMeta';

const OG_IMAGE_PATH = '/assets/logo.png';

function getOgImageUrl() {
  const origin = getSiteOrigin();
  return origin ? `${origin}${OG_IMAGE_PATH}` : OG_IMAGE_PATH;
}

function ensureMeta(selector, createFn) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = createFn();
    document.head.appendChild(el);
  }
  return el;
}

function setNameMeta(name, content) {
  if (content == null || content === '') return;
  const el = ensureMeta(`meta[name="${name}"]`, () => {
    const m = document.createElement('meta');
    m.setAttribute('name', name);
    return m;
  });
  el.setAttribute('content', content);
}

function setPropertyMeta(property, content) {
  if (content == null || content === '') return;
  const el = ensureMeta(`meta[property="${property}"]`, () => {
    const m = document.createElement('meta');
    m.setAttribute('property', property);
    return m;
  });
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * @param {object} opts
 * @param {string} opts.title
 * @param {string} opts.description
 * @param {string} opts.keywords
 * @param {string} [opts.robots]
 * @param {string} path - pathname only (no query), e.g. /home
 */
export function applyPageSeo(opts, path) {
  const title = opts.title || siteDefaults.title;
  const description = opts.description || siteDefaults.description;
  const keywords = opts.keywords || siteDefaults.keywords;
  const robots = opts.robots;

  const canonicalUrl = getCanonicalUrlForPath(path);

  document.title = title;

  setNameMeta('description', description);
  setNameMeta('keywords', keywords);

  setPropertyMeta('og:title', title);
  setPropertyMeta('og:description', description);
  if (canonicalUrl) {
    setPropertyMeta('og:url', canonicalUrl);
    setNameMeta('twitter:url', canonicalUrl);
  }
  const ogImage = getOgImageUrl();
  setPropertyMeta('og:image', ogImage);
  setPropertyMeta('og:image:type', 'image/png');
  setPropertyMeta('og:type', 'website');
  setPropertyMeta('og:locale', 'en_US');
  setPropertyMeta('og:locale:alternate', 'my_MM');

  setNameMeta('twitter:card', 'summary_large_image');
  setNameMeta('twitter:title', title);
  setNameMeta('twitter:description', description);
  setNameMeta('twitter:image', ogImage);

  if (robots) {
    setNameMeta('robots', robots);
  } else {
    setNameMeta('robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
  }

  if (canonicalUrl) {
    setCanonical(canonicalUrl);
  }
}
